var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.30435C13.9589 8.30435 12.3043 9.95895 12.3043 12C12.3043 14.0411 13.9589 15.6957 16 15.6957C18.0411 15.6957 19.6957 14.0411 19.6957 12C19.6957 9.95895 18.0411 8.30435 16 8.30435ZM11 12C11 9.23858 13.2386 7 16 7C18.7614 7 21 9.23858 21 12C21 14.7614 18.7614 17 16 17C13.2386 17 11 14.7614 11 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 24.3824C8 20.7416 11.7149 18 16 18C20.2851 18 24 20.7416 24 24.3824C24 24.7235 23.7124 25 23.3576 25C23.0028 25 22.7152 24.7235 22.7152 24.3824C22.7152 21.6489 19.8348 19.2353 16 19.2353C12.1652 19.2353 9.2848 21.6489 9.2848 24.3824C9.2848 24.7235 8.99719 25 8.6424 25C8.28761 25 8 24.7235 8 24.3824Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3f15f337.svg";
export { ForwardRef as ReactComponent };